// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import { Zenith } from '@zenith-game/core';

export default {
    0: () => import('./Z00_Tutorial/Z00.definition'),
} as Zenith.ZoneMap;
